import React, { useEffect, useState, useMemo } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';
import useUserStore from '../../store/UserStore';
import { getTicket } from '../../services/ticket_api'; 
import { t } from '../Language/Translator';
import { format } from 'date-fns';
import Loader from '../commonForm/Loader'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCallRecordings } from '../../services/ticket_api';
import Pagination from '../commonForm/Pagination';

const CallRecording = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const queryClient = useQueryClient();
    const user_data = useUserStore((state) => state.user);
    const token = useMemo(() => user_data, [user_data]);

    const { data: recordingsToDisplay, isLoading, error } = useQuery({ queryKey: ['call(recordings)', currentPage], queryFn: () => getCallRecordings(token, ticketId, currentPage) })

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        queryClient.invalidateQueries({ queryKey: ['call(recordings)', pageNumber] });
    };

    const { ticketId } = useParams();
    const [ticketDetails, setTicketDetails] = useState(null);
    const [callRecordings, setCallRecordings] = useState([]); // State to hold call recordings
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchTicketDetails = async () => {
            setLoading(true);
            try {
                const response = await getTicket(token, ticketId);
                console.log("CallRecording-24=>", response);
                if (response.status !== 'success') {
                    throw new Error('Network response was not ok.');
                }
                setTicketDetails(response.data);
            } catch (error) {
                toast.error('Failed to fetch ticket details.');
            } finally {
                setLoading(false);
            }
        };

        if (ticketId && token) {
            fetchTicketDetails();
        }
    }, [ticketId, token]);

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <>
            <ToastContainer />
            <div className="top_section">
                <div className="pagesNamelink">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/dashboard">{t("admindashboard.dashboard")}</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/tickets">{t("tickets.ticket")}</Link>
                            </li>
                            <li className="breadcrumb-item active text-white" aria-current="page">Call Recording</li>
                        </ol>
                    </nav>
                    <h4 className="text-white">Call Recording</h4>
                </div>
            </div>
            <div className="mainSection">
                {/* <h5 className="text-white">Ticket Details</h5> */}
                {ticketDetails ? (
                    <div className="ticket-details d-block mb-3">
                        <div className='d-flex gap-3 justify-content-between flex-wrap'>
                        <div className="">
                            <p className='m-0'><strong>Ticket ID: </strong> 
                            {ticketDetails.ticketId}
                           
                            </p>
                            </div>
                             <div className="">
                            <p className='m-0'><strong>Analyst Name: </strong> 
                            {ticketDetails.analyst_first_name}
                            
                            </p>
                        </div>
                        <div className="">
                            <p className='m-0'><strong>Customer Name: </strong> 
                            {ticketDetails.customer_first_name}
                           
                            </p>
                        </div>
                        </div>
                    </div>
                ) : (
                    <div className="no-data text-white">No ticket details available.</div>
                )}
                {!error &&
                    <>
                        <div className="mainTable table-responsive">
                            {isLoading && <Loader />}
                            <table id="example" className="table table-striped table-dark">
                                {recordingsToDisplay &&
                                    <>
                                        <thead>
                                            <tr>
                                                <th>CallSid</th>
                                                <th>Recording Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {recordingsToDisplay.data.length > 0 && recordingsToDisplay.data.map((recording, index) => {
                                                return (
                                                    <tr key={recording.id}>
                                                        <td style={{ whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word', hyphens: 'auto', maxWidth: '100px' }}>{recording.callSid}</td>
                                                        <td>{format(recording.createdAt, "MM/dd/yyyy hh:mm a") || 'N.A'}</td>
                                                        <td>
                                                            <Link to={ recording.recordingUrl } target="_blank" className="btn btn-primary mt-2">
                                                                Listen Recording
                                                            </Link>
                                                            {/* <audio controls> */}
                                                                {/* <source src={`https://consolestage.decept10.com/api/call/recording/${recording.recordingSid}`} type="audio/mpeg" /> */}
                                                            {/* </audio> */}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            {recordingsToDisplay.data.length == 0 && <p className='text-center text-white mt-4'>No results found!</p>}
                                        </tbody>
                                    </>
                                }
                            </table>

                        </div>
                        {recordingsToDisplay?.data.length>0 &&  
                        <div>
                            <Pagination
                                itemsPerPage={10}
                                totalItems={recordingsToDisplay?.pagination?.totalItems}
                                paginate={paginate}
                                currPage={currentPage}
                            />
                        </div>
                        }
                    </>
                }
                {error &&
                    <p className='text-center text-white mt-4'>Something went wrong. Please try again later !</p>
                }
            </div>
        </>
    );
};

export default CallRecording;
